import { useMemo } from "react";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import * as allActions from "./actions";

/**
 * Hook providing bound action creators for the offers Redux slice.
 * @returns {Object} Bound action creators: updateOffers, updateOffersFilters, setOffersFilters, loadOffersFilters, clearOffers, clearOffersFilters
 */
export function useOffersActions() {
  const dispatch = useDispatch();
  return useMemo(() => bindActionCreators(allActions, dispatch), [dispatch]);
}
